import React from "react";
import { useTranslation } from "react-i18next";
import {
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
} from "reactstrap";
import { VerticalDotsIcon } from "@aureskonnect/react-ui";

import { HomeSvgIcon } from "@components/Common/SvgIcons";
import AddUserSvgIcon from "@components/Common/SvgIcons/AddUserSvgIcon";
import ErrorToast from "@components/Common/ErrorTost";

export function DropDownWrapper({ data }: any) {
    const { t } = useTranslation();
    const [isDropdownOpened, setIsDropdownOpened] = React.useState(false);
    function toggleDropdown() {
        setIsDropdownOpened((prevState) => !prevState);
    }

    return (
        <React.Fragment>
            {data.selectedRowData.selectedRow.original.shopId !== "0" &&
            data.selectedRowData.selectedRow.original[t("Third party")] ===
                "Uber direct" ? (
                <Dropdown isOpen={isDropdownOpened} toggle={toggleDropdown}>
                    <DropdownToggle
                        id="page-header-user-dropdown"
                        tag="button"
                        className="pointer__clz btn btn header-item waves-effect"
                    >
                        <VerticalDotsIcon
                            height={25}
                            width={25}
                            className="Cgt_drp_menuProject"
                        />
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem
                            style={{
                                cursor: "pointer",
                            }}
                            className="cgt_icn_consult"
                            onClick={() => {
                                data.setSelectedRows([
                                    data.selectedRowData.selectedRow.original,
                                ]);
                                data.setIsCreateOrganizationModalOpened(true);
                            }}
                        >
                            <HomeSvgIcon
                                height={25}
                                width={25}
                                className="pointer__clz ml-1"
                            />
                            <span>
                                {t(
                                    data.selectedRowData.selectedRow.original
                                        ?.organization?.organization_id !==
                                        undefined
                                        ? "Consult organization"
                                        : "Create organization"
                                )}
                            </span>
                        </DropdownItem>
                        <DropdownItem
                            style={{
                                cursor: "pointer",
                            }}
                            className="cgt_icn_consult"
                            onClick={() => {
                                if (
                                    data.selectedRowData.selectedRow.original
                                        .organization?.organization_id ===
                                        undefined ||
                                    data.selectedRowData.selectedRow.original
                                        .organization?.organization_id === ""
                                ) {
                                    ErrorToast(
                                        `${t(
                                            "Attention, to be able to add users, you must first create an organization."
                                        )} `
                                    );
                                } else {
                                    data.setSelectedRows([
                                        data.selectedRowData.selectedRow
                                            .original,
                                    ]);
                                    data.setIsCreateEmployeeModalOpened(true);
                                }
                            }}
                        >
                            <AddUserSvgIcon
                                height={25}
                                width={25}
                                className="pointer__clz ml-1"
                            />
                            <span>{t("Add employee")}</span>
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            ) : (
                <div></div>
            )}
        </React.Fragment>
    );
}
